// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#react-personal-area .visualCaptcha-explanation,
#react-header-app .visualCaptcha-explanation {
  width: 100%;
  margin: 0 0 10px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
}

#react-personal-area div.visualCaptcha,
#react-header-app div.visualCaptcha {
  margin: 0 !important;
}

#react-personal-area .visualCaptcha-explanation strong,
#react-header-app .visualCaptcha-explanation strong {
  display: inline-block;
  margin-left: 5px;
}

#react-personal-area .visualCaptcha .visualCaptcha-possibilities,
#react-header-app .visualCaptcha .visualCaptcha-possibilities {
  display: flex;
  flex-direction: row;
}

#react-personal-area .visualCaptcha .visualCaptcha-refresh-button,
#react-header-app .visualCaptcha .visualCaptcha-refresh-button {
  cursor: pointer;
}

#react-personal-area .visualCaptcha-possibilities .img,
#react-header-app .visualCaptcha-possibilities .img {
  width: 60px;
  height: 60px;
}

#react-personal-area .react-tel-input .form-control,
#react-header-app .react-tel-input .form-control {
  width: 100%;
  height: 45px;
  font-weight: 400;
  font-size: 16px;
  font-family: 'Proxima Nova',serif;
  border-radius: 8px;
  background: #FFF;
  box-shadow: 0px 1px 12px 0px rgba(173, 141, 141, 0.20);
  backdrop-filter: blur(8.5px);
  padding-left: 60px;
  border: none;
}
#react-personal-area .react-tel-input .form-control::placeholder,
#react-hambureger-menu .react-tel-input .form-control::placeholder {
  color: #999;
  opacity: 1; /* Firefox */
}

#react-personal-area .react-tel-input .flag-dropdown,
#react-header-app .react-tel-input {
  border: none;
  background: white;
  padding-left: 12px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.react-tel-input .flag-dropdown::after {
  content: '';
  display: block;
  height: 50%;
  width: 1px;
  background: #C4C4C4;
  position: absolute;
  top: 25%;
  right: 0px;
}

.react-tel-input .selected-flag {
  padding-right: 33px !important;
}

#react-sidebar-app {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-shrink: 0;
  gap: 20px;
  padding: 12px 9px;
  width: 200px;
  background: #fff;

  @media (max-width: 767px) {
    display: none;
  }
}

#react-sidebar-app.react-sidebar-app--hidden {
  display: none;
}

.profile-menu__section-mock {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.profile-menu-hack {
  background: whitesmoke;
  margin-top: 0;
  padding-top: 5px;
  display: none;
}

#react-personal-area ::-webkit-scrollbar,
#react-header-app ::-webkit-scrollbar {
  width: 4px;
}

/* Track */
#react-personal-area ::-webkit-scrollbar-track,
#react-header-app ::-webkit-scrollbar-track {
  background: none;
}
 
/* Handle */
#react-personal-area ::-webkit-scrollbar-thumb,
#react-header-app ::-webkit-scrollbar-thumb {
	border-radius: 2px;
	background: #D9D9D9;
}

/* Handle on hover */
#react-personal-area ::-webkit-scrollbar-thumb:hover,
#react-header-app ::-webkit-scrollbar-thumb:hover {
  background: rgba(51, 51, 51, 1); 
  cursor: pointer;
}

.personal-area-page {
  display: flex;
  /* header 66px, footer 56px */
  min-height: calc(100vh - 122px);
}

.personal-area-wrapper {
  display: flex;
  min-height: 100%;
  align-self: stretch;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  background: #F8F8F8;
  min-width: 0;
}

#react-personal-area {
  width: 100%;
  height: 100%;
}

/* CAPTCHA STYLES */
.visualCaptcha-accessibility-button:hover,.visualCaptcha-possibilities img:hover,.visualCaptcha-refresh-button:hover {
  cursor: pointer
}
.visualCaptcha {
  margin-bottom: 20px;
  min-height: 120px;
}
.is-mobile .visualCaptcha {
  margin: 0;
}
.visualCaptcha * {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.visualCaptcha .audioField {
  font-size: 15px;
  color: #495e62;
  font-weight: 100;
  padding: 5px;
  border: 1px solid #3bb6e4;
  height: 40px;
  width: 100%;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
}
@media only screen and (max-width: 360px) {
  .visualCaptcha .audioField {
    margin-bottom:15px;
  }
}
@media only screen and (min-width: 360px) {
  .visualCaptcha .audioField {
    width:240px;
    float: left;
  }
}
.accessibility-description,.status.valid,.visualCaptcha-explanation {
  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  border-radius: 7px;
  background-color: #c1f7e8;
  padding: 10px;
  text-align: center;
  font-family: Oxygen,sans-serif;
  font-size: 18px;
  color: #219589;
  font-weight: 100;
  margin: 20px 0 24px;
}
.visualCaptcha-accessibility-button,.visualCaptcha-button-group,.visualCaptcha-possibilities,.visualCaptcha-refresh-button {
  display: inline-block
}
.visualCaptcha-possibilities {
  vertical-align: middle
}
.visualCaptcha-possibilities .img {
  padding: 4px;
  border: 1px solid #fff;
  display: inline-block;
}
.visualCaptcha-possibilities img {
  width: 32px;
  height: 32px;
  z-index: 5;
  transition: all .2s;
  -webkit-transition: all .2s;
}
.visualCaptcha-accessibility-button img,.visualCaptcha-refresh-button img {
  width: 16px;
  height: 16px;
}
@media only screen and (max-width: 360px) {
  .accessibility-description,.status.valid,.visualCaptcha-explanation {
    font-size:16px;
  }
  .visualCaptcha-possibilities .visualCaptcha-button-group {
    text-align: center;
    margin-top: 15px;
  }
}
@media only screen and (min-width: 750px) {
  .visualCaptcha-possibilities {
    margin-right:15px;
  }
  .visualCaptcha-possibilities .img {
    padding: 10px;
    border: 3px solid #fff;
  }
  .visualCaptcha-possibilities .visualCaptcha-button-group {
    float: right;
  }
}
.visualCaptcha-possibilities .visualCaptcha-selected {
  background-color: #c1f7e8;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  padding: 4px;
  border: 1px dashed #099a9f;
}
@media only screen and (min-width: 750px) {
  .visualCaptcha-possibilities .visualCaptcha-selected {
    padding:10px;
    border: 3px dashed #099a9f;
  }
}
.visualCaptcha-refresh-button {
  padding: 9px 10px 7px;
  margin: 0 5px;
  background-color: #f87056;
  border: 1px solid #f87056;
  -webkit-border-radius: 100px;
  -moz-border-radius: 100px;
  border-radius: 100px;
}
.visualCaptcha-accessibility-button {
  padding: 9px 10px 7px;
  border: 1px solid #000;
  -webkit-border-radius: 100px;
  -moz-border-radius: 100px;
  border-radius: 100px;
}
@-webkit-keyframes fadeIn {
  from {
    opacity: 0
  }

  to {
    opacity: 1
  }
}
@keyframes fadeIn {
  from {
    opacity: 0
  }

  to {
    opacity: 1
  }
}
@-webkit-keyframes fadeOut {
  from {
    opacity: 1
  }
  to {
    opacity: 0
  }
}
@keyframes fadeOut {
  from {
    opacity: 1
  }
  to {
    opacity: 0
  }
}
div.visualCaptcha .visualCaptcha-show {
  -webkit-animation: fadeIn .3s;
  animation: fadeIn .3s;
}
div.visualCaptcha .visualCaptcha-hide {
  display: none!important;
  -webkit-animation: fadeOut .3s;
  animation: fadeOut .3s;
}

/* Change Autocomplete styles in Chrome*/
input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-text-fill-color: initial;
  -webkit-box-shadow: 0 0 0 1000px white inset !important;
}

.rc-table-container>.rc-table-body {
  overscroll-behavior: none;
}
`, "",{"version":3,"sources":["webpack://./src/loader/css/global.css"],"names":[],"mappings":"AAAA;;EAEE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,sDAAsD;EACtD,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;AACd;AACA;;EAEE,WAAW;EACX,UAAU,EAAE,YAAY;AAC1B;;AAEA;;EAEE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;;EAEhB;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,UAAU;AACZ;;AAEA,UAAU;AACV;;EAEE,gBAAgB;AAClB;;AAEA,WAAW;AACX;;CAEC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA,oBAAoB;AACpB;;EAEE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE;AACF;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,WAAW;IACX,WAAW;EACb;AACF;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE;AACF;AACA;EACE;AACF;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,sBAAsB;EACxB;EACA;IACE,YAAY;EACd;AACF;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE;IACE,YAAY;IACZ,0BAA0B;EAC5B;AACF;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,4BAA4B;EAC5B,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,oBAAoB;AACtB;AACA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;AACA;EACE;IACE;EACF;;EAEA;IACE;EACF;AACF;AACA;EACE;IACE;EACF;EACA;IACE;EACF;AACF;AACA;EACE;IACE;EACF;EACA;IACE;EACF;AACF;AACA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;;;;;;;;;EASE,gCAAgC;EAChC,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["#react-personal-area .visualCaptcha-explanation,\n#react-header-app .visualCaptcha-explanation {\n  width: 100%;\n  margin: 0 0 10px;\n  height: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n#react-personal-area div.visualCaptcha,\n#react-header-app div.visualCaptcha {\n  margin: 0 !important;\n}\n\n#react-personal-area .visualCaptcha-explanation strong,\n#react-header-app .visualCaptcha-explanation strong {\n  display: inline-block;\n  margin-left: 5px;\n}\n\n#react-personal-area .visualCaptcha .visualCaptcha-possibilities,\n#react-header-app .visualCaptcha .visualCaptcha-possibilities {\n  display: flex;\n  flex-direction: row;\n}\n\n#react-personal-area .visualCaptcha .visualCaptcha-refresh-button,\n#react-header-app .visualCaptcha .visualCaptcha-refresh-button {\n  cursor: pointer;\n}\n\n#react-personal-area .visualCaptcha-possibilities .img,\n#react-header-app .visualCaptcha-possibilities .img {\n  width: 60px;\n  height: 60px;\n}\n\n#react-personal-area .react-tel-input .form-control,\n#react-header-app .react-tel-input .form-control {\n  width: 100%;\n  height: 45px;\n  font-weight: 400;\n  font-size: 16px;\n  font-family: 'Proxima Nova',serif;\n  border-radius: 8px;\n  background: #FFF;\n  box-shadow: 0px 1px 12px 0px rgba(173, 141, 141, 0.20);\n  backdrop-filter: blur(8.5px);\n  padding-left: 60px;\n  border: none;\n}\n#react-personal-area .react-tel-input .form-control::placeholder,\n#react-hambureger-menu .react-tel-input .form-control::placeholder {\n  color: #999;\n  opacity: 1; /* Firefox */\n}\n\n#react-personal-area .react-tel-input .flag-dropdown,\n#react-header-app .react-tel-input {\n  border: none;\n  background: white;\n  padding-left: 12px;\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n}\n\n.react-tel-input .flag-dropdown::after {\n  content: '';\n  display: block;\n  height: 50%;\n  width: 1px;\n  background: #C4C4C4;\n  position: absolute;\n  top: 25%;\n  right: 0px;\n}\n\n.react-tel-input .selected-flag {\n  padding-right: 33px !important;\n}\n\n#react-sidebar-app {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  flex-shrink: 0;\n  gap: 20px;\n  padding: 12px 9px;\n  width: 200px;\n  background: #fff;\n\n  @media (max-width: 767px) {\n    display: none;\n  }\n}\n\n#react-sidebar-app.react-sidebar-app--hidden {\n  display: none;\n}\n\n.profile-menu__section-mock {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.profile-menu-hack {\n  background: whitesmoke;\n  margin-top: 0;\n  padding-top: 5px;\n  display: none;\n}\n\n#react-personal-area ::-webkit-scrollbar,\n#react-header-app ::-webkit-scrollbar {\n  width: 4px;\n}\n\n/* Track */\n#react-personal-area ::-webkit-scrollbar-track,\n#react-header-app ::-webkit-scrollbar-track {\n  background: none;\n}\n \n/* Handle */\n#react-personal-area ::-webkit-scrollbar-thumb,\n#react-header-app ::-webkit-scrollbar-thumb {\n\tborder-radius: 2px;\n\tbackground: #D9D9D9;\n}\n\n/* Handle on hover */\n#react-personal-area ::-webkit-scrollbar-thumb:hover,\n#react-header-app ::-webkit-scrollbar-thumb:hover {\n  background: rgba(51, 51, 51, 1); \n  cursor: pointer;\n}\n\n.personal-area-page {\n  display: flex;\n  /* header 66px, footer 56px */\n  min-height: calc(100vh - 122px);\n}\n\n.personal-area-wrapper {\n  display: flex;\n  min-height: 100%;\n  align-self: stretch;\n  flex-direction: column;\n  flex-grow: 1;\n  flex-shrink: 1;\n  background: #F8F8F8;\n  min-width: 0;\n}\n\n#react-personal-area {\n  width: 100%;\n  height: 100%;\n}\n\n/* CAPTCHA STYLES */\n.visualCaptcha-accessibility-button:hover,.visualCaptcha-possibilities img:hover,.visualCaptcha-refresh-button:hover {\n  cursor: pointer\n}\n.visualCaptcha {\n  margin-bottom: 20px;\n  min-height: 120px;\n}\n.is-mobile .visualCaptcha {\n  margin: 0;\n}\n.visualCaptcha * {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.visualCaptcha .audioField {\n  font-size: 15px;\n  color: #495e62;\n  font-weight: 100;\n  padding: 5px;\n  border: 1px solid #3bb6e4;\n  height: 40px;\n  width: 100%;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n}\n@media only screen and (max-width: 360px) {\n  .visualCaptcha .audioField {\n    margin-bottom:15px;\n  }\n}\n@media only screen and (min-width: 360px) {\n  .visualCaptcha .audioField {\n    width:240px;\n    float: left;\n  }\n}\n.accessibility-description,.status.valid,.visualCaptcha-explanation {\n  -webkit-border-radius: 7px;\n  -moz-border-radius: 7px;\n  border-radius: 7px;\n  background-color: #c1f7e8;\n  padding: 10px;\n  text-align: center;\n  font-family: Oxygen,sans-serif;\n  font-size: 18px;\n  color: #219589;\n  font-weight: 100;\n  margin: 20px 0 24px;\n}\n.visualCaptcha-accessibility-button,.visualCaptcha-button-group,.visualCaptcha-possibilities,.visualCaptcha-refresh-button {\n  display: inline-block\n}\n.visualCaptcha-possibilities {\n  vertical-align: middle\n}\n.visualCaptcha-possibilities .img {\n  padding: 4px;\n  border: 1px solid #fff;\n  display: inline-block;\n}\n.visualCaptcha-possibilities img {\n  width: 32px;\n  height: 32px;\n  z-index: 5;\n  transition: all .2s;\n  -webkit-transition: all .2s;\n}\n.visualCaptcha-accessibility-button img,.visualCaptcha-refresh-button img {\n  width: 16px;\n  height: 16px;\n}\n@media only screen and (max-width: 360px) {\n  .accessibility-description,.status.valid,.visualCaptcha-explanation {\n    font-size:16px;\n  }\n  .visualCaptcha-possibilities .visualCaptcha-button-group {\n    text-align: center;\n    margin-top: 15px;\n  }\n}\n@media only screen and (min-width: 750px) {\n  .visualCaptcha-possibilities {\n    margin-right:15px;\n  }\n  .visualCaptcha-possibilities .img {\n    padding: 10px;\n    border: 3px solid #fff;\n  }\n  .visualCaptcha-possibilities .visualCaptcha-button-group {\n    float: right;\n  }\n}\n.visualCaptcha-possibilities .visualCaptcha-selected {\n  background-color: #c1f7e8;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  padding: 4px;\n  border: 1px dashed #099a9f;\n}\n@media only screen and (min-width: 750px) {\n  .visualCaptcha-possibilities .visualCaptcha-selected {\n    padding:10px;\n    border: 3px dashed #099a9f;\n  }\n}\n.visualCaptcha-refresh-button {\n  padding: 9px 10px 7px;\n  margin: 0 5px;\n  background-color: #f87056;\n  border: 1px solid #f87056;\n  -webkit-border-radius: 100px;\n  -moz-border-radius: 100px;\n  border-radius: 100px;\n}\n.visualCaptcha-accessibility-button {\n  padding: 9px 10px 7px;\n  border: 1px solid #000;\n  -webkit-border-radius: 100px;\n  -moz-border-radius: 100px;\n  border-radius: 100px;\n}\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0\n  }\n\n  to {\n    opacity: 1\n  }\n}\n@keyframes fadeIn {\n  from {\n    opacity: 0\n  }\n\n  to {\n    opacity: 1\n  }\n}\n@-webkit-keyframes fadeOut {\n  from {\n    opacity: 1\n  }\n  to {\n    opacity: 0\n  }\n}\n@keyframes fadeOut {\n  from {\n    opacity: 1\n  }\n  to {\n    opacity: 0\n  }\n}\ndiv.visualCaptcha .visualCaptcha-show {\n  -webkit-animation: fadeIn .3s;\n  animation: fadeIn .3s;\n}\ndiv.visualCaptcha .visualCaptcha-hide {\n  display: none!important;\n  -webkit-animation: fadeOut .3s;\n  animation: fadeOut .3s;\n}\n\n/* Change Autocomplete styles in Chrome*/\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover, \ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n  -webkit-text-fill-color: initial;\n  -webkit-box-shadow: 0 0 0 1000px white inset !important;\n}\n\n.rc-table-container>.rc-table-body {\n  overscroll-behavior: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
